import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { resetPassword, apiErr } from "@/lib/api";
import { PasswordInput } from "@/components/ui-bits";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); if (busy) return;
    if (pw.length < 8) return setErr("Password must be at least 8 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true); setErr("");
    try { await resetPassword(token, pw); setDone(true); }
    catch (e) { setErr(apiErr(e?.response?.data?.detail)); setBusy(false); }
  };
  return (
    <div className="auth-screen" data-testid="reset-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-agency">MAKE IT HAPPEN PHILLY</div>
        <h1 className="auth-title">Set a new password</h1>
        {!token && <div className="auth-err">This reset link is missing its token.</div>}
        {done ? (
          <>
            <p className="auth-sub" data-testid="reset-done">Your password has been updated. You can now sign in.</p>
            <button className="auth-btn" type="button" onClick={() => navigate("/login")} data-testid="reset-tologin">Go to Sign In</button>
          </>
        ) : (
          <>
            <label className="auth-lbl">New password
              <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" testid="reset-pw" />
            </label>
            <label className="auth-lbl">Confirm new password
              <PasswordInput value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" testid="reset-pw2" />
            </label>
            {err && <div className="auth-err" data-testid="reset-error">{err}</div>}
            <button className="auth-btn" type="submit" disabled={busy || !token} data-testid="reset-submit">{busy ? "Saving…" : "Update password"}</button>
          </>
        )}
        <Link to="/login" className="auth-link">Back to Sign In</Link>
      </form>
    </div>
  );
}
